import { FC, PropsWithChildren } from "react";
import styles from './PageBase.module.css';

export const PageBase: FC<PropsWithChildren<{overflow?: "auto"}>> = ({ children, overflow }) => {
    return <section className={`${styles['Page']} ${overflow ? styles['Page--overflow'] : ''}`}>
        {children}
    </section>
}